import { withPlugins, device } from '@spon/plugins';
import Flickity from 'flickity-fade';

function Carousel({ node, plugins: { device } }) {
	// Default arrows & dots to false
	const defaultConfig = {
		cellAlign: 'left',
		cellSelector: '[data-slide]',
		contain: true,
		draggable: true,
		pageDots: false,
		pauseAutoPlayOnHover: false,
		wrapAround: true,
		prevNextButtons: false,
		arrowShape:
			'm68.7 0 13.1 13.1-36.5 37.4 36.4 36.4-13 13.1-50.5-49.5L68.7 0z',
	};

	const config = node.dataset.config ? JSON.parse(node.dataset.config) : {};
	const combinedConfig = { ...defaultConfig, ...config };

	const carousel = new Flickity(node, combinedConfig);

	device.resize(() => {
		if (carousel) carousel.resize();
	});

	return () => {
		carousel.destroy();
	};
}

export default withPlugins(device)(Carousel);
